<form
  class="flex flex-col justify-between md:px-10 xl:w-[1300px]"
  [formGroup]="accommodationFormService.accommodationForm"
>
  <section class="m-auto flex max-w-[500px] flex-1 flex-col md:gap-10">
    <div class="flex flex-col gap-4">
      <h2 class="text-center text-primary-900">
        {{ "prestation.accommodation.title" | transloco }}
      </h2>
      <p class="text-center text-paragraph-s-reg">
        {{ "prestation.accommodation.description" | transloco }}
      </p>
    </div>
    <div class="flex flex-col items-start">
      <label for="title" class="text-paragraph-xs-med text-greyscale-700">
        {{ "prestation.transportTitle.label" | transloco
        }}<span class="text-greyscale-500">
          ({{ "optional" | transloco }})</span
        >
      </label>
      <input
        pInputText
        id="title"
        formControlName="title"
        [fluid]="true"
        [placeholder]="'prestation.accommodationTitle.placeholder' | transloco"
      />
      <app-error
        [control]="accommodationFormService.accommodationForm.get('title')!"
      />
    </div>
  </section>
  <app-select-accommodation-type />
  <div class="flex flex-col gap-4">
    @if (accommodationFormService.displayCustomEmissionFactors) {
      <app-select-custom-accommodation-factor />
    }
    <div class="flex flex-col gap-4 md:flex-row">
      <section class="flex flex-1 flex-col gap-4 rounded-lg bg-primary-50 p-4">
        <div class="flex flex-col gap-2">
          <h4 class="text-primary-900">
            {{ "prestation.country.title" | transloco }}
          </h4>
          <p class="text-paragraph-xs-reg">
            {{ "prestation.country.description" | transloco }}
          </p>
        </div>
        <app-select-country
          [formGroup]="accommodationFormService.accommodationForm"
        />
      </section>
      <section class="flex flex-1 flex-col gap-4 rounded-lg bg-primary-50 p-4">
        <div class="flex flex-col gap-2">
          <h4 class="text-primary-900">
            {{ "prestation.accommodationDetails.title" | transloco }}
          </h4>
        </div>
        <div class="flex flex-col items-start">
          <label for="nights" class="text-paragraph-xs-med text-greyscale-700">
            {{ "calculator.placeholder.nights" | transloco }}
          </label>
          <p-inputNumber id="nights" formControlName="nights" [fluid]="true" />
          <app-error
            [control]="
              accommodationFormService.accommodationForm.get('nights')!
            "
          />
        </div>
        @if (!displayPerPerson) {
          <div class="flex flex-col items-start">
            <label
              for="peoplePerRoom"
              class="text-paragraph-xs-med text-greyscale-700"
            >
              {{
                (displayPerRoom
                  ? "calculator.label.peoplePerRoom"
                  : "calculator.label.peoplePerAccommodation"
                ) | transloco
              }}
            </label>
            <p-inputNumber
              id="peoplePerRoom"
              formControlName="peoplePerRoom"
              [fluid]="true"
            />
            <app-error
              [control]="
                accommodationFormService.accommodationForm.get('peoplePerRoom')!
              "
            />
          </div>
        }
      </section>
    </div>
    <div class="flex flex-col gap-4 md:flex-row">
      <section class="flex flex-1 flex-col gap-4 rounded-lg bg-primary-50 p-4">
        <div class="flex flex-col gap-2">
          <h4 class="text-primary-900">
            {{ "prestation.isEcoFriendly.title" | transloco }}
          </h4>
          <p class="text-paragraph-xs-reg">
            {{ "prestation.isEcoFriendly.description" | transloco }}
          </p>
        </div>
        <div class="flex flex-row gap-4">
          <div class="flex flex-1 items-center">
            <p-checkbox
              formControlName="isEcoFriendly"
              [binary]="true"
              id="isEcoFriendly"
              class="mr-2"
            />
            <label
              for="isEcoFriendly"
              class="text-paragraph-xs-med text-greyscale-700"
            >
              {{ "calculator.placeholder.ecoFriendly" | transloco }}
            </label>
          </div>
        </div>
      </section>
      <section class="flex flex-1 flex-col gap-4 rounded-lg bg-primary-50 p-4">
        <div class="flex flex-col gap-2">
          <h4 class="text-primary-900">
            {{ "prestation.scheduledDays.title" | transloco }}
          </h4>
          <p class="text-paragraph-xs-reg">
            {{ "prestation.scheduledDays.description" | transloco }}
          </p>
        </div>
        <app-scheduled-days-selector
          [formGroup]="accommodationFormService.accommodationForm"
        />
      </section>
    </div>
  </div>
</form>
<div class="flex flex-row items-end justify-end gap-4">
  <p-button
    [label]="'close' | transloco"
    (click)="close()"
    severity="secondary"
    [text]="true"
  />

  <p-button
    [label]="'save' | transloco"
    (click)="submit()"
    [loading]="loading"
    [disabled]="accommodationFormService.accommodationForm.invalid"
  />
</div>
